import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { AxiosError } from "axios";
import { DisableTmaisUserValidationSchema } from "../schemas/disableTmaisUser.schema";

interface UseDisableTmaisClientProps {
  id?: string;
  onSuccess?: () => void;
  onError?: (error: AxiosError) => void;
}

const useDisableTmaisClient = ({ id, onSuccess, onError }: UseDisableTmaisClientProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation<void, AxiosError, DisableTmaisUserValidationSchema>({
    mutationKey: ['disableTmaisUser', id],
    mutationFn: async (data) => {
      await privateAxios.post(`/tmais/users/${id}/disable`, data);
    },
    onSuccess,
    onError,
  });
};

export default useDisableTmaisClient;
